import {useEffect, useState, useRef, useContext} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Badge} from "react-bootstrap";
import Moment from "moment/moment";
import NavDropdown from "react-bootstrap/NavDropdown";
import {Link, useNavigate, useLocation} from "react-router-dom";
import AuthContext from "context/AuthContext";
// -

import WsConnector from "core/wsConnector";
import WebSocketApp from "./WebSocketApp";
import ModalMessage from "components/notifications/ModalMessage";
import axiApi from "ApiCaller";
import {publishEvent, subscribeEvent, unsubscribeEvent} from "core/eventsConnector";

const NavMessages = () => {
    const {logoutUser, updatePanel} = useContext(AuthContext);
    const items = useRef({
        showed: [],
    });
    const [unreadMessages, setUnreadMessages] = useState(0);
    const [lastMessages, setLastMessages] = useState([]);

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);

    const userLang = localStorage.getItem("i18nextLng") || "es";

    const handleToggleDropdown = (isOpen) => {
        setIsDropdownOpen(isOpen); // Actualiza el estado del menú desplegable
    };

    const wsConn = new WsConnector();
    wsConn.message = (e) => {
        let data = JSON.parse(e.data);
        if (data.type === "app.message") {
            if (data.message.action === "panel_changed") {
                updatePanel(data.message.panel);
            } else if (data.message.action === "refresh_user") {
                logoutUser();
            } else {
                console.log("Mensaje de app no reconocido:", data.message);
            }
        } else if (data.type === "notify.message") {
            items.current.showed.push(data.message);
            setLastMessages([...items.current.showed]);
            setUnreadMessages((prevUnreadMessages) => prevUnreadMessages + 1);
        }
    };

    function messageIsRead(event) {
        const id = event.detail.id;
        const ids = event.detail.ids;
        if (id === null && ids === null) return;

        if (ids) {
            setLastMessages((prev) => prev.map((message) => (ids.includes(message.id) ? {...message, read: true} : message)));
            setUnreadMessages(0);
        } else {
            setLastMessages((prev) => prev.map((message) => (message.id === id ? {...message, read: true} : message)));
            setUnreadMessages((prev) => Math.max(0, prev - 1));
        }
    }

    const messageIsDelete = (event) => {
        const id = event.detail.id;
        if (id === null) return;
        setLastMessages((prev) => prev.filter((message) => parseInt(message.id) !== id));
        setUnreadMessages((prev) => Math.max(0, prev - 1));
    };

    const onClickMessage = (message) => {
        setItemSelected(message);
        setShowAlert(true);
    };

    useEffect(() => {
        wsConn.setUrl("/ws/notifications/");
        wsConn.connect();

        axiApi.get(`/api/notify/get/last/`).then((resp) => {
            items.current.showed = [...resp.data.items];
            setLastMessages([...resp.data.items]);
            setUnreadMessages(resp.data.unread_count);
        });

        subscribeEvent("messageRead", messageIsRead);
        subscribeEvent("messageDeleted", messageIsDelete);
        return () => {
            unsubscribeEvent("messageRead", messageIsRead);
            subscribeEvent("messageDeleted", messageIsDelete);
            wsConn.close();
        };
    }, []);

    const getResultColor = (result) => {
        switch (result) {
            case "i": // Info
                return "#007bff"; // Azul
            case "s": // Success
                return "#28a745"; // Verde
            case "w": // Warning
                return "#fd7e14"; // Naranja
            case "e": // Error
                return "#dc3545"; // Rojo
            default:
                return "#6c757d"; // Gris por defecto
        }
    };

    const getMostImportantColor = () => {
        if (unreadMessages === 0) return "#6c757d"; // Gris si no hay mensajes

        const unreadMessagesData = lastMessages.filter((msg) => !msg.read);

        // Prioridad: Error > Warning > Success > Info
        const priorities = {e: 4, w: 3, s: 2, i: 1};
        let maxPriority = 0;
        let maxResult = null;

        unreadMessagesData.forEach((msg) => {
            const result = msg?.notify?.result;
            if (result) {
                const priority = priorities[result] || 0;
                if (priority > maxPriority) {
                    maxPriority = priority;
                    maxResult = result;
                }
            }
        });

        const badgeClass = maxResult ? getResultColor(maxResult) : "#6c757d";
        return badgeClass;
    };

    const dropdownTitle = (
        <span className="ps-1 pe-1 position-relative">
            <FontAwesomeIcon icon="message" className="me-2" />
            <span
                className="badge rounded-pill position-absolute top-0 start-100 translate-middle"
                style={{
                    backgroundColor: getMostImportantColor(),
                    color: "white",
                    padding: "0.35em 0.65em",
                    fontSize: "0.75em",
                    fontWeight: "700",
                    lineHeight: "1",
                }}>
                {unreadMessages}
            </span>
        </span>
    );

    return (
        <>
            <NavDropdown
                title={dropdownTitle}
                id="message-nav-dropdown"
                show={isDropdownOpen}
                onToggle={handleToggleDropdown}
                drop="down"
                align="end">
                {lastMessages.map((message, index) => {
                    const texts = message.notify.texts || {};
                    const text = texts[userLang] || texts["es"] || texts[Object.keys(texts)[0]] || {};
                    const resultColor = getResultColor(message.notify.result);

                    return (
                        <NavDropdown.Item
                            key={index}
                            style={{
                                fontWeight: message.read ? "normal" : "bold",
                                borderLeft: `4px solid ${resultColor}`,
                                paddingLeft: "12px",
                            }}
                            onClick={() => onClickMessage(message)}>
                            {text.title} {Moment(message.notify.created_at).format("DD/MM/YYYY HH:mm:ss")}
                        </NavDropdown.Item>
                    );
                })}

                <NavDropdown.Divider />
                <Link
                    data-rr-ui-dropdown-item=""
                    className="dropdown-item"
                    role="button"
                    tabIndex="0"
                    to={"/notifications/"}
                    onClick={() => setIsDropdownOpen(false)}>
                    Ver todos
                </Link>
                {itemSelected != null ? (
                    <ModalMessage showAlert={showAlert} setShowAlert={setShowAlert} itemSelected={itemSelected} />
                ) : (
                    <></>
                )}
            </NavDropdown>
            <WebSocketApp />
        </>
    );
};
export default NavMessages;
